module.exports = __webpack_public_path__ + "static/media/alert-icon.f98a50fc.svg";